import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDom from 'react-dom';
import Page from '../shared/components/Page';
import { configureClientInstrumentation } from './lib/client-instrumentation';
import { attachAnalyticsListeners } from '@spotify-internal/touchdown-analytics';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn:
    'https://09d927c146bb46728e7b701c2122e066@o22381.ingest.sentry.io/6303532',
  sampleRate: 0.2,
  environment: window.SPOTI_DATA.environment,
  release: window.SPOTI_DATA.release,
  beforeSend: event => (window.SPOTI_DATA.useErrorReporting ? event : null),
  ignoreErrors: [/(Time to paint|navigationTiming) api is not supported/gim],
});

if (window.SPOTI_DATA.useInstrumentation) {
  configureClientInstrumentation();
}

const baseElement = document.getElementById('spoti-root');
ReactDom.hydrate(
  <Sentry.ErrorBoundary>
    <Page {...window.SPOTI_DATA} />
  </Sentry.ErrorBoundary>,
  baseElement,
);

const isAuthenticated = window.SPOTI_DATA.user.authenticated || false;
const pageName = window.SPOTI_DATA.pageName || '';
const resourceName = window.SPOTI_DATA.resourceName || '';
const countryCode = window.SPOTI_DATA.country || '';
const eventParams = window.SPOTI_DATA.pageData.eventParams || {};

attachAnalyticsListeners({
  analyticsRoot: baseElement!,
  isAuthenticated,
  pageName,
  resourceName,
  countryCode,
  eventParams,
});
